import React, { useState, useEffect, useMemo } from 'react';

import { getOverviewTimeline } from '@/pages/opinion/services/performance';
import CardCommon from '@/pages/opinion/components/CardCommon';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import { useRequestLifetimePcConsole } from '../../hooks/useRequestLifetimePcConsole';
import SteamStoreScoreBox from './SteamStoreScoreBox';
import { DBO_TM } from '@op/utils/format';

export default function SteamReviews({ gameInfo, filter }: any) {
  const { formatMessage } = useLanguage();

  const params = useMemo(() => {
    if (filter && gameInfo) {
      const { channel, ...otherFilter } = filter;
      return { ...otherFilter, ...gameInfo, channels: ['steam'], device: '' };
    }
    return {};
  }, [filter]);

  const {
    loading: scoreLoading,
    data: storeScoreInfo,
    changeTime,
    show,
    time,
    isToday,
  } = useRequestLifetimePcConsole({
    filter: params,
  });

  const [steamReviews, setSteamReviews] = useState([]);
  const getPcGameStoreData = (params: any) => {
    const { social_media_by_account, social_media_by_keyword, ...otherFilter } =
      params;
    getOverviewTimeline({
      ...otherFilter,
      channel: ['steam'],
      channel_type: 'comments',
      metrics: ['recommend', 'non_recommend'],
      ret_metrics: ['recommend', 'non_recommend'],
      types: ['total'], // , 'slice'
    }).then((data: any) => {
      const { total_list } = data || {};

      setSteamReviews(total_list || []);
    });
  };

  useEffect(() => {
    if (Object.keys(filter || {}).length > 0) {
      getPcGameStoreData({ ...filter, ...gameInfo });
    }
  }, [filter, gameInfo]);

  return (
    <CardCommon
      className="feeds-gamestorebox"
      title={formatMessage({ id: 'Game Store' })}
      loading={scoreLoading}
      loadingHeight={200}
    >
      <>
        <SteamStoreScoreBox
          loading={scoreLoading}
          storeScoreInfo={storeScoreInfo}
          changeTime={changeTime}
          steamReviews={steamReviews}
          show={show}
          time={time}
          addedTime={DBO_TM.timeTitle({ ...filter, link_text: ' ~ ' })}
          filter={filter}
          isToday={isToday}
        />
      </>
    </CardCommon>
  );
}
